import Icon from '../components/Icon.vue'

Icon.register({
  'drum-steelpan': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M288 32C128.9 32 0 89.3 0 160V352C0 422.7 128.9 480 288 480S576 422.7 576 352V160C576 89.3 447.1 32 288 32zM205 190.4C200.6 207 190.5 220.9 176.7 230.8 100.2 217.5 48 190.8 48 160 48 129.8 98.1 103.6 172 90L197.6 134.3C207.5 151.4 210.1 171.3 205 190.4zM288 240C266.9 240 246.6 239 227.1 237.3 235.2 211.2 259.3 192 288 192S340.8 211.2 348.9 237.3C329.4 239 309.1 240 288 240zM352 96C352 131.3 323.3 160 288 160S224 131.3 224 96V83C244.4 81.1 265.8 80 288 80S331.6 81.1 352 83V96zM398.9 230.9C385.1 221 375 207 370.5 190.4 365.4 171.3 368 151.4 377.9 134.3L403.6 89.9C477.7 103.5 528 129.8 528 160 528 190.8 475.6 217.5 398.9 230.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/drum-steelpan.js
// module id = gW55
// module chunks = 144